function EscalationPlanRiskLevel() {
    "use strict";

    this.__type = 'EscalationPlanRiskLevel:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.AgentId = -1;
    this.EscalationPlanId = -1;
    this.IsActive = true;
    this.RiskLevelId = -1;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = EscalationPlanRiskLevel;
}